import React, { useState, useEffect, forwardRef } from "react";
import { Form, Select, DatePicker, Row, Col, Input, Space } from "antd";
import dayjs from "dayjs";

const { Option } = Select;
const { RangePicker } = DatePicker;

function SearchParam(props, ref) {
  const { filters, refreshData } = props;
  const [form] = Form.useForm();
  const [config, setConfig] = useState(filters);
  const [formValues, setFormValues] = useState({});
  console.log(config);
  if (ref) {
    ref.current = {
      getValue: () => {
        return config;
      },
    };
  }

  // 初始化表单值
  useEffect(() => {
    const initialValues = {};
    config.forEach((item) => {
      if (item.selected && item.selected.length > 0) {
        // 特殊处理：如果是 start_date 或 end_date，需要组合成 RangePicker 的数组格式
        if (item.key === "start_date" || item.key === "end_date") {
          // 这里逻辑稍后在 render 中通过 form.setFieldsValue 统一处理更安全
          return;
        }
        initialValues[item.key] = item.multi ? item.selected : item.selected[0];
      }
    });

    // 处理 RangePicker 的初始值
    const startItem = config.find((i) => i.key === "start_date");
    const endItem = config.find((i) => i.key === "end_date");
    if (startItem?.selected[0] && endItem?.selected[0]) {
      initialValues["graduation_year"] = [
        dayjs(startItem.selected[0], handleFormat(startItem.picker)),
        dayjs(endItem.selected[0], handleFormat(endItem.picker)),
      ];
    }

    form.setFieldsValue(initialValues);
    setFormValues(initialValues);
  }, []);

  // 核心逻辑：当表单值变化时，更新 config 中的 selected
  const handleValuesChange = (changedValues, allValues) => {
    refreshData();
    setFormValues(allValues);

    setConfig((prevConfig) => {
      return prevConfig.map((item) => {
        const changedKey = Object.keys(changedValues)[0]; // 获取变化的字段名

        // 1. 处理普通 Select 和 单个 Date
        if (changedKey === item.key) {
          let newValue = allValues[item.key];
          let selectedArray = [];

          if (item.type === "date" && !Array.isArray(newValue)) {
            // 单个日期
            selectedArray = newValue ? [newValue.format("YYYY-MM-DD")] : [];
          } else {
            // Select 或多选
            selectedArray = Array.isArray(newValue)
              ? newValue
              : newValue !== undefined && newValue !== null
              ? [newValue]
              : [];
          }

          return { ...item, selected: selectedArray };
        }

        // 2. 处理 RangePicker (虚拟键名 'graduation_year') -> 拆分回写到 start_date 和 end_date
        if (
          changedKey === "graduation_year" &&
          (item.key === "start_date" || item.key === "end_date")
        ) {
          const rangeValues = allValues["graduation_year"]; // [dayjs, dayjs]

          if (rangeValues && Array.isArray(rangeValues)) {
            const formatStr =
              item.key === "start_date"
                ? rangeValues[0]?.format(handleFormat(item.picker))
                : rangeValues[1]?.format(handleFormat(item.picker));

            return {
              ...item,
              selected: formatStr ? [formatStr] : [],
            };
          } else {
            // 清空情况
            return { ...item, selected: [] };
          }
        }

        return item;
      });
    });
  };

  //处理format格式
  const handleFormat = (val) => {
    console.log(val, "format格式");
    if (val === "month") {
      return "YYYY-MM";
    } else if (val === "year") {
      return "YYYY";
    } else if (val === "week") {
      return "YYYY-w"; // 补全：例如 2026-19
    } else if (val === "quarter") {
      return "YYYY-Q"; // 补全：例如 2026-2
    } else {
      return "YYYY-MM-DD";
    }
  };

  const isDisabled = (item) => {
    if (!item.depends_on || item.depends_on.length === 0) return false;
    return item.depends_on.some((depKey) => !formValues[depKey]);
  };

  // 渲染特殊字段：毕业年份 (RangePicker)
  const renderSpecialFields = () => {
    const hasStart = config.find((i) => i.key === "start_date");
    const hasEnd = config.find((i) => i.key === "end_date");
    console.log(hasStart, "hasStart");
    if (hasStart && hasEnd) {
      return (
        // <Col span={8} key="graduation-year">
        <Form.Item label={hasStart?.label_zh || ""} name="graduation_year">
          <RangePicker
            picker={hasStart?.picker ? hasStart.picker : "date"}
            style={{ width: "100%" }}
            placeholder={["开始年份", "结束年份"]}
          />
        </Form.Item>
        // </Col>
      );
    }
    return null;
  };

  return (
    <Form
      form={form}
      layout="inline"
      onValuesChange={handleValuesChange}
      style={{ padding: 20 }}
      variant="borderless"
    >
      <Space wrap>
        {/* <Row gutter={24} align="middle"> */}
        {config.map((item) => {
          // 跳过被合并的日期字段
          if (item.key === "start_date" || item.key === "end_date") return null;

          // 渲染 Select
          if (item.type === "select") {
            return (
              //   <Col span={8} key={item.key}>
              <Form.Item
                label={item.key === "xslb" ? "培养层次" : item.label_zh}
                name={item.key}
              >
                <Select
                  allowClear
                  showSearch
                  placeholder={`请选择`}
                  style={{ width: 180 }}
                  disabled={isDisabled(item)}
                  options={item?.options || []}
                >
                  {/* {item.options.map((opt) => (
                    <Option key={opt} value={opt}>
                      {opt}
                    </Option>
                  ))} */}
                </Select>
              </Form.Item>
              //   </Col>
            );
          }
          return null;
        })}

        {/* 渲染合并后的 RangePicker */}
        {renderSpecialFields()}
        {/* </Row> */}
      </Space>
    </Form>
  );
}

export default forwardRef(SearchParam);
